import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = {
  key: 0,
  class: "app-button__loader"
}
const _hoisted_3 = {
  key: 1,
  class: "app-button__icon app-button__icon--left"
}
const _hoisted_4 = {
  key: 2,
  class: "app-button__content"
}
const _hoisted_5 = {
  key: 3,
  class: "app-button__icon app-button__icon--right"
}
const _hoisted_6 = {
  key: 4,
  class: "app-button__badge"
}

import { computed } from 'vue'

// Define props interface
interface Props {
  variant?: 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info' | 'light' | 'dark' | 'outline' | 'text'
  size?: 'small' | 'medium' | 'large'
  loading?: boolean
  disabled?: boolean
  block?: boolean
  iconLeft?: boolean
  iconRight?: boolean
  iconOnly?: boolean
  rounded?: boolean
  elevated?: boolean
  soft?: boolean
  badge?: string | number | null
}

// Define emits
interface Emits {
  click: [event: MouseEvent]
}

// Define props with defaults

export default /*@__PURE__*/_defineComponent({
  __name: 'AppButton',
  props: {
    variant: { default: 'primary' },
    size: { default: 'medium' },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    block: { type: Boolean, default: false },
    iconLeft: { type: Boolean, default: false },
    iconRight: { type: Boolean, default: false },
    iconOnly: { type: Boolean, default: false },
    rounded: { type: Boolean, default: false },
    elevated: { type: Boolean, default: false },
    soft: { type: Boolean, default: false },
    badge: { default: null }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

/// <reference types="vue" />
// @ts-ignore
const props = __props

// Define emits
const emit = __emit

// Computed properties for validation
const isValidVariant = computed(() => {
  const validVariants = ['primary', 'secondary', 'success', 'danger', 'warning', 'info', 'light', 'dark', 'outline', 'text']
  return validVariants.includes(props.variant)
})

const isValidSize = computed(() => {
  const validSizes = ['small', 'medium', 'large']
  return validSizes.includes(props.size)
})

// Methods
const handleClick = (event: MouseEvent): void => {
  if (!props.disabled && !props.loading) {
    emit('click', event)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("button", {
    class: _normalizeClass([
      'app-button', 
      `app-button--${_ctx.variant}`,
      `app-button--${_ctx.size}`,
      { 'app-button--loading': _ctx.loading },
      { 'app-button--block': _ctx.block },
      { 'app-button--icon-only': _ctx.iconOnly },
      { 'app-button--rounded': _ctx.rounded },
      { 'app-button--elevated': _ctx.elevated },
      { 'app-button--soft': _ctx.soft }
    ]),
    disabled: _ctx.disabled || _ctx.loading,
    onClick: handleClick
  }, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2))
      : _createCommentVNode("", true),
    (_ctx.iconLeft)
      ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
          _renderSlot(_ctx.$slots, "icon-left")
        ]))
      : _createCommentVNode("", true),
    (!_ctx.loading)
      ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
          _renderSlot(_ctx.$slots, "default")
        ]))
      : _createCommentVNode("", true),
    (_ctx.iconRight)
      ? (_openBlock(), _createElementBlock("span", _hoisted_5, [
          _renderSlot(_ctx.$slots, "icon-right")
        ]))
      : _createCommentVNode("", true),
    (_ctx.badge)
      ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.badge), 1))
      : _createCommentVNode("", true)
  ], 10, _hoisted_1))
}
}

})